const MEDIA_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20style%20illustration%20with%20action%20movie%20themed%20abstract%20elements%2C%20dynamic%20motion%20lines%20and%20dramatic%20lighting%20effects%20in%20warm%20coral%20and%20deep%20amber%20tones%2C%20movie%20poster%20inspired%20flat%20design%2C%20bold%20composition%20on%20dark%20gradient%20background&width=800&height=500&seq=media-action-11&orientation=landscape',
    title: '动作大片专区',
    desc: '肾上腺素飙升的动作片合集',
    duration: '200+部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20playful%20comedy%20themed%20digital%20illustration%20with%20bright%20cheerful%20colors%20in%20yellow%20and%20soft%20green%20tones%2C%20fun%20abstract%20shapes%20and%20laughter%20visual%20metaphors%2C%20lighthearted%20flat%20design%20style%2C%20warm%20inviting%20composition&width=800&height=500&seq=media-comedy-12&orientation=landscape',
    title: '喜剧精选合集',
    desc: '欢乐不停的搞笑影片精选',
    duration: '150+部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20soft%20illustration%20with%20warm%20peach%20and%20pink%20gradient%20tones%2C%20delicate%20abstract%20heart%20and%20flower%20motifs%20blended%20with%20film%20elements%2C%20dreamy%20editorial%20style%2C%20tender%20elegant%20composition%20on%20light%20cream%20background&width=800&height=500&seq=media-romance-13&orientation=landscape',
    title: '爱情电影特辑',
    desc: '甜蜜与感动交织的浪漫故事',
    duration: '120+部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20themed%20illustration%20with%20abstract%20geometric%20shapes%20and%20digital%20effects%20in%20cool%20teal%20and%20warm%20coral%20accents%2C%20space%20and%20technology%20motifs%2C%20clean%20modern%20flat%20design%20style%2C%20bold%20minimalist%20composition&width=800&height=500&seq=media-scifi-14&orientation=landscape',
    title: '科幻奇幻天地',
    desc: '超越想象的科幻巨制盛宴',
    duration: '90+部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20thriller%20themed%20illustration%20with%20dramatic%20shadows%20and%20mysterious%20atmosphere%20in%20deep%20charcoal%20and%20warm%20amber%20accents%2C%20abstract%20tension%20visuals%2C%20minimalist%20cinematic%20style%2C%20intriguing%20composition%20on%20dark%20gradient&width=800&height=500&seq=media-thriller-15&orientation=landscape',
    title: '悬疑烧脑剧场',
    desc: '高智商悬疑片让你猜不到结局',
    duration: '80+部',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          按类型发现你感兴趣的精彩内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}